import { api } from '@/scripts/api';

export const ExitSurveyService = {
    async saveExitSurvey(accountId, request) {
        return api.post(`/ms/exit-surveys/v1/exitSurvey/account/${accountId}`, request);
    },

    async get(exitSurveyId) {
        return api.get(`/ms/exit-surveys/v1/exitSurvey/surveys/${exitSurveyId}`);
    },

    async getAll(config) {
        return new Promise((resolve, reject) => {
            const service = '/ms/exit-surveys/v1/exitSurvey/surveys';

            const axiosConfig = {
                url: service,
                params: {...api.getNodeDataParams(config) }
            };

            api.ajax(axiosConfig)
                .then(resolve)
                .catch(reject);
        });
    },

    async getCount(queryParams) {
        const service = '/ms/exit-surveys/v1/exitSurvey/surveys';
        const response = await api.get(`${service}?${queryParams}`);
        
        return response.data.data.count;
    },

    async getResponses(queryParams) {
        const service = '/ms/exit-surveys/v1/exitSurvey/responses';
        const response = await api.get(`${service}?${queryParams}`);
        
        return response.data.data;
    },

    async getAllIds() {
        return api.get('/ms/exit-surveys/v1/exitSurvey/ids');
    },

    async exportRecords(exitSurveyIds) {
        return await api.post('/ms/exit-surveys/v1/exitSurvey/export', { exitSurveyIds});
    },

    async getExitSurveyResponseDetails(config) {
        return new Promise((resolve, reject) => {
            const service = '/ms/exit-surveys/v1/exitSurvey/responseSummary';

            const axiosConfig = {
                url: service,
                params: {...api.getNodeDataParams(config) }
            };

            api.ajax(axiosConfig)
                .then(resolve)
                .catch(reject);
        });
    },
}